import { render, staticRenderFns } from "./selectSpace.vue?vue&type=template&id=3479ffa9&scoped=true&"
import script from "./selectSpace.vue?vue&type=script&lang=js&"
export * from "./selectSpace.vue?vue&type=script&lang=js&"
import style0 from "./selectSpace.vue?vue&type=style&index=0&id=3479ffa9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479ffa9",
  null
  
)

export default component.exports